import { Link } from "react-router-dom";
import type { ReactNode } from "react";

export default function InsightsShell({ children, eyebrow = "Premier Pharma Insights" }: { children: ReactNode; eyebrow?: string }) {
  return <div className="min-h-screen bg-[#f8fafb] text-slate-900">
    <section className="relative overflow-hidden bg-[#082b49] px-4 py-16 text-white sm:px-6 lg:px-8">
      <div className="absolute -right-24 -top-32 h-96 w-96 rounded-full bg-[#14919b]/30 blur-3xl" />
      <div className="relative mx-auto max-w-6xl">
        <Link to="/insights" className="text-sm font-semibold text-cyan-200 hover:text-white">{eyebrow}</Link>
        {children}
      </div>
    </section>
  </div>;
}